export const environment = {
  production: false,
  // apiUrl: 'https://tottoqr.prod.solunes.com/',
  apiUrl: 'https://qrtottobackend.gruposfr.com/',
  versionApp: '1.0.0',
  title: 'Totto',
  imgLogo: '/assets/img/logo.png',
  loaderType: 1,
  loaderText: 'Cargando...',
  keyEncript: '3fa85f64c2f9e0c53fa85f64c2f9e0c5',
  ivEncript: '3fa85f64c2f9e0c53fa85f64c2f9e0c5',
};